import request from '@/utils/request'
const apiPath = '/sys/sysGiftAccountReason'
const sysGiftAccountReasonApi = {
  /**
   * 新增【赠送账户原因】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【赠送账户原因】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【赠送账户原因】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【赠送账户原因】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【赠送账户原因】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【赠送账户原因】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【赠送账户原因】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
  setIsEnableService(data) {
    return request.put(apiPath + '/setIsEnable', data)
  },
  /**
   * 查询【赠送账户原因】选项列表
   */
  findOption(query) {
    return request.get(`${apiPath}/findAllAccountReason`, { params: query })
  },
  listReasonPz(data) {
    return request.post(apiPath + '/listReasonPz', data, { isFormData: 1 })
  },
  saveReasonPz(data) {
    return request.post(apiPath + '/saveReasonPz', data)
  },
  updateReasonPz(data) {
    return request.post(apiPath + '/updateReasonPz', data)
  },
  removeReasonPz(data) {
    return request.post(apiPath + '/removeReasonPz', data, { isFormData: 1 })
  },
}
export default sysGiftAccountReasonApi
